import {
  SET_PRODUCTS,
  PRODUCTS_LOADING,
  PRODUCTS_ERROR,
  PRODUCTS_NOT_FOUND,
  SET_SELECTED_PRODUCT,
} from '../types/ProductTypes';

const initialState = {
  products: [],
  loading: false,
  error: false,
  finished: false,
  selectedProduct: {},
};

const productReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_PRODUCTS:
      return {
        ...state,
        loading: false,
        products: action.products,
        error: false,
        finished: true,
      };
    case PRODUCTS_LOADING:
      return { ...state, loading: true, finished: false };
    case PRODUCTS_NOT_FOUND:
      return { ...state, loading: false, error: false, finished: true };
    case PRODUCTS_ERROR:
      return { ...state, loading: false, error: true, finished: true };
    case SET_SELECTED_PRODUCT:
      return { ...state, selectedProduct: action.product };
    default:
      return state;
  }
};

export default productReducer;
